import { createFeature, createReducer, on } from '@ngrx/store';
import { DepotPieceElementAnnee, DepotPieceReutilisable } from '@pieces-api';
import { piecesJustificativesActions } from './pieces-justificatives.actions';

const PIECES_JUSTIFICATIVES_FEATURE_KEY = 'piecesJustificatives';

export interface State {
  pieces: DepotPieceElementAnnee[] | null;
  reutilisables: DepotPieceReutilisable[] | null;
  selectedPiece: DepotPieceElementAnnee | null;
  loading: boolean;
  downloadingPieceId: string | null;
  uploadingPieceId: string | null;
  updatingConcernPieceId: string | null;
  reusingPieceId: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any | null;
}

export const initialPiecesJustificativesState: State = {
  pieces: null,
  reutilisables: null,
  selectedPiece: null,
  loading: false,
  downloadingPieceId: null,
  uploadingPieceId: null,
  updatingConcernPieceId: null,
  reusingPieceId: null,
  error: null,
};

export const piecesJustificativesFeature = createFeature({
  name: PIECES_JUSTIFICATIVES_FEATURE_KEY,
  reducer: createReducer(
    initialPiecesJustificativesState,

    // Load pieces
    on(piecesJustificativesActions.loadPieces, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(piecesJustificativesActions.loadPiecesSuccess, (state, action) => ({
      ...state,
      pieces: action.pieces,
      reutilisables: action.reutilisables,
      loading: false,
      error: null,
    })),
    on(piecesJustificativesActions.loadPiecesFailure, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    // Download piece
    on(piecesJustificativesActions.downloadPiece, (state, action) => ({
      ...state,
      downloadingPieceId: action.request.idDemandePiece,
      error: null,
    })),
    on(piecesJustificativesActions.downloadPieceSuccess, (state) => ({
      ...state,
      downloadingPieceId: null,
      error: null,
    })),
    on(piecesJustificativesActions.downloadPieceFailure, (state, action) => ({
      ...state,
      downloadingPieceId: null,
      error: action.error,
    })),

    // Upload piece (deposit or replace)
    on(piecesJustificativesActions.uploadPiece, (state, action) => ({
      ...state,
      uploadingPieceId: action.request.pieceId,
      error: null,
    })),
    on(piecesJustificativesActions.uploadPieceFailure, (state, action) => ({
      ...state,
      uploadingPieceId: null,
      error: action.error,
    })),

    // Update concern status
    on(piecesJustificativesActions.updateConcernStatus, (state, action) => ({
      ...state,
      updatingConcernPieceId: action.request.idDemandePiece,
      error: null,
    })),
    on(piecesJustificativesActions.updateConcernStatusFailure, (state, action) => ({
      ...state,
      updatingConcernPieceId: null,
      error: action.error,
    })),

    // Reuse piece
    on(piecesJustificativesActions.reusePiece, (state, action) => ({
      ...state,
      reusingPieceId: action.request.idDemandePiece,
      error: null,
    })),
    on(piecesJustificativesActions.reusePieceSuccess, (state) => ({
      ...state,
      reusingPieceId: null,
      error: null,
    })),
    on(piecesJustificativesActions.reusePieceFailure, (state, action) => ({
      ...state,
      reusingPieceId: null,
      error: action.error,
    })),

    // Clear error
    on(piecesJustificativesActions.clearError, (state) => ({
      ...state,
      error: null,
    })),
  ),
});
